// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import UserDisplaySectionContainer from './UserDisplaySectionContainer'

function DataComponent() {
  return (
    <div>
      <UserDisplaySectionContainer header="Data">
        <Link to='/users/archived' className="ui-btn ui-btn--blue">View archived projects</Link>
      </UserDisplaySectionContainer>
    </div>
  );
}

export default DataComponent;
